export default __webpack_public_path__ + "static/media/cog.59cd0730.svg";